import React from 'react'
import Svg from './Svg'
export const SvgMenu = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 3h24v5.142H0zm0 6.858h24V15H0zm0 6.856h24v5.144H0z" />
  </Svg>
))
SvgMenu.isIcon = true
export default SvgMenu
